import { Injectable, inject } from '@angular/core';
import { OrganisationsDataService, OrganisationModel } from '@seahorse/domain';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrganisationStoreService {
  private _orgService = inject(OrganisationsDataService);

  organisations: OrganisationModel[] = [];
  private _byId = new Map<string, OrganisationModel>();
  loaded = false;

  load(): Observable<boolean> {
    return this._orgService.getOrganisations().pipe(
      map((res) => {
        if (res.hasResult) {
          this.organisations = res.result;
          this._byId = new Map(
            res.result.map((org) => [String(org.id).toLowerCase(), org])
          );
          this.loaded = true;
        }
        return true;
      }),
      catchError(() => of(false))
    );
  }

  getName(id: string | null | undefined): string {
    if (id == null) return '';
    return this._byId.get(String(id).toLowerCase())?.name ?? '';
  }

  getById(id: string | null | undefined): OrganisationModel | undefined {
    if (id == null) return undefined;
    return this._byId.get(String(id).toLowerCase());
  }

  getAll(): OrganisationModel[] {
    return this.organisations;
  }
}
